"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportMenu = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const core_api_2 = require("@ikegps/core-api");
const image_button_1 = require("../../components/button/image.button");
const icons_1 = require("../../components/icon/icons");
const menu_1 = require("../../components/menu/menu");
const menu_item_1 = require("../../components/menu/menu.item");
const mithril_component_1 = require("../../components/mithril.component");
const modal_service_1 = require("../../components/modal/modal.service");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const i18n_1 = require("../../i18n");
const mithril_1 = require("../../mithril");
const index_1 = require("../../services/index");
const page_state_1 = require("../../state/page.state");
const ReportMaker_1 = require("../report/ReportMaker");
const export_menu_ctrl_1 = require("./export.menu.ctrl");
class ExportMenu extends mithril_component_1.IMithrilComponent {
    constructor(state) {
        super();
        this.state = state;
        this.menu = new menu_1.MenuComponent({
            items: () => this.viewDownloadItems(),
        });
    }
    get nodes() {
        if (this.state.exporting || !page_state_1.CurrentState.Tag.ready) {
            return spinner_1.Spinner.view();
        }
        const userProfile = index_1.Services.UserProfile.get(index_1.Services.User.current.objectId);
        if (!index_1.Services.UserProfile.canExportReports(userProfile)) {
            return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                title: i18n_1.T.EXPORT_MENU_TITLE_PERMISSION,
                disabled: true,
            });
        }
        if (page_state_1.CurrentState.CollectionEdit.isDirty) {
            return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                title: i18n_1.T.EXPORT_MENU_TITLE_DIRTY,
                disabled: true,
            });
        }
        if (page_state_1.CurrentState.Tag.collections.length > core_api_1.CollectionExportPolicy.MAX_LIMIT) {
            return image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                title: i18n_1.T.EXPORT_MENU_TITLE_LIMIT,
                titleAttrs: { limit: core_api_1.CollectionExportPolicy.MAX_LIMIT },
                disabled: true,
            });
        }
        return (0, mithril_1.m)('div', [
            image_button_1.ImageButton.view(icons_1.MaterialIcon.FILE_DOWNLOAD, {
                title: i18n_1.T.EXPORT_MENU_TITLE,
                onclick: this.menu.show,
                id: 'export-menu',
            }),
            this.menu.view(),
        ]);
    }
    viewDownloadItems() {
        const oneCollectionSelected = page_state_1.CurrentState.Tag.collections.length === 1;
        const tagsSelected = Boolean(page_state_1.CurrentState.Tag.tags.length);
        const canReportShort = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_SHORT);
        const hasReportCompositePhoto = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_COMPOSITE_PHOTO) ||
            index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        const hasReportCompositePhotoOnly = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_COMPOSITE_ONLY);
        const hasReportPhoto = index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_REPORT_PHOTO) || index_1.Services.Token.has(core_api_2.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
        // This ensures that all collections have the same form revision which is required for importing excel
        const canExportImportableExcel = page_state_1.CurrentState.Tag.collections.every((collectionSummery) => collectionSummery.formRevision === page_state_1.CurrentState.Tag.collections[0].formRevision) && index_1.Services.Token.hasAll([core_api_2.IkeToken.FEATURE_IMPORT_CSV, core_api_2.IkeToken.FEATURE_IMPORT_EXCEL]);
        return [
            {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_KML)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => export_menu_ctrl_1.ExportMenuController.exportKML()),
            },
            {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXCEL)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => export_menu_ctrl_1.ExportMenuController.exportExcel()),
            },
            {
                visible: canExportImportableExcel,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.IMPORTABLE_EXCEL)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => tslib_1.__awaiter(this, void 0, void 0, function* () { return yield export_menu_ctrl_1.ExportMenuController.exportImportableExcel(); })),
            },
            {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_JSON)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => export_menu_ctrl_1.ExportMenuController.exportJSON()),
            },
            {
                visible: tagsSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => this.exportPDF(ReportMaker_1.ReportTypeEnum.ReportType, i18n_1.T.EXPORT_REPORT)),
            },
            {
                visible: tagsSelected && canReportShort,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_SHORT)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => this.exportPDF(ReportMaker_1.ReportTypeEnum.ReportShortType, i18n_1.T.EXPORT_REPORT_SHORT)),
            },
            {
                visible: tagsSelected && hasReportCompositePhoto,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => this.exportPDF(ReportMaker_1.ReportTypeEnum.ReportCompositePhotoType, i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO)),
            },
            {
                visible: tagsSelected && hasReportCompositePhotoOnly,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO_ONLY)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => this.exportPDF(ReportMaker_1.ReportTypeEnum.ReportCompositePhotoOnlyType, i18n_1.T.EXPORT_REPORT_COMPOSITE_PHOTO_ONLY)),
            },
            {
                visible: tagsSelected && hasReportPhoto,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_REPORT_PHOTO)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => this.exportPDF(ReportMaker_1.ReportTypeEnum.ReportPhotoType, i18n_1.T.EXPORT_REPORT_PHOTO)),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasOCalcForm(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_O_CALC)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => export_menu_ctrl_1.ExportMenuController.exportOCalc()),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasSPIDACalcForm(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_SPIDA_CALC)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => export_menu_ctrl_1.ExportMenuController.exportSPIDACalc(false)),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasSPIDACalcForm(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_SPIDA_CALC_NO_PHOTO)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => export_menu_ctrl_1.ExportMenuController.exportSPIDACalc(true)),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasPoleforeman(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_POLEFOREMAN)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => export_menu_ctrl_1.ExportMenuController.exportPoleforeman()),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasIkePoleForeman(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_IKE_POLEFOREMAN)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => export_menu_ctrl_1.ExportMenuController.exportIkePoleForeman()),
                id: 'export-ipf',
            },
            {
                visible: oneCollectionSelected,
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_IMAGE_ZIP)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => export_menu_ctrl_1.ExportMenuController.exportImageZip()),
            },
            {
                visible: tagsSelected && export_menu_ctrl_1.ExportMenuController.hasDDS(page_state_1.CurrentState.Tag.collections),
                view: menu_item_1.MenuItemComponent.view((0, i18n_1.Translate)(i18n_1.T.EXPORT_DDS)),
                action: () => export_menu_ctrl_1.ExportMenuController.runExport(this.state, () => export_menu_ctrl_1.ExportMenuController.exportDDS()),
            },
        ];
    }
    exportPDF(type, reportNameTranslationKey) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            modal_service_1.ModalService.open({
                title: (0, i18n_1.Translate)(i18n_1.T.EXPORTING_PDF_TITLE),
                content: (0, mithril_1.m)('div', {}, [
                    (0, mithril_1.m)('div', { style: { marginBottom: theme_1.DefaultTheme.space(2) } }, (0, i18n_1.Translate)(i18n_1.T.EXPORTING_PDF_CONTENT)),
                    spinner_1.Spinner.view(),
                ]),
                hasCancel: false,
            });
            // Perform license check to see if a PDF export can be made for this user
            const result = yield index_1.Services.Department.rest.Department.User.isLicensed(null);
            if (result.results) {
                (yield export_menu_ctrl_1.ExportMenuController.exportReport(type)).download(`${(0, i18n_1.Translate)(reportNameTranslationKey)} ${new Date().toDateString()}`, () => modal_service_1.ModalService.close());
            }
            else {
                index_1.Services.License.hasNoLicense = true;
                modal_service_1.ModalService.close();
            }
        });
    }
}
exports.ExportMenu = ExportMenu;
//# sourceMappingURL=export.menu.js.map